import type { FleetPeriod } from "../../../../types/chargingStationDashboard";

export interface PanelProps {
  selected: FleetPeriod;
  previous: FleetPeriod | null;
  /** Oldest first, ending with `selected`. */
  trend: FleetPeriod[];
}

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

/** Short axis labels: "Sep 26" for a month, "W38" for a week. The full label lives in the tooltip title. */
export const axisLabel = (period: FleetPeriod): string => {
  const week = /^\d{4}-W(\d{2})$/.exec(period.key);
  if (week) return `W${week[1]}`;
  const month = /^(\d{4})-(\d{2})$/.exec(period.key);
  if (month) return `${MONTHS[Number(month[2]) - 1]} ${month[1].slice(2)}`;
  return period.label;
};

/**
 * The AC/DC split is drawn only when every period on the chart carries it. A trend where some periods
 * predate power-type data would otherwise show those periods as all-"unclassified", which reads as a
 * real change in the fleet when it is only a change in what was known (FR-025).
 */
export const splitDrawable = (periods: FleetPeriod[]): boolean =>
  periods.length > 0 && periods.every((p) => p.splitAvailable);

/** An unclassified remainder is shown only when it exists, so it is never an empty legend entry. */
export const hasUnclassified = (periods: FleetPeriod[], pick: (p: FleetPeriod) => number): boolean =>
  periods.some((p) => pick(p) > 0);
